/*global window,console*/
/*eslint no-console:0*/
define('app/models/Monitor',['require','./AnalyticsEntity','./MonitorData','config','glu/http','app/store','app/config/strings','glu/$','glu/util','glu/appBus','app/app'],function(require) {
	'use strict';

	var AnalyticsEntity = require('./AnalyticsEntity'),
		MonitorData = require('./MonitorData'),
		config = require('config'),
		http = require('glu/http'),
		sessionStore = require('app/store'),
		strings = require('app/config/strings'),
		$ = require('glu/$'),
		_ = require('glu/util'),
		appBus = require('glu/appBus'),
		App = require('app/app');

	return AnalyticsEntity.extend({

		http: http,

		url: function() {
			return config.apiRoot + 'service/monitor/' + this.id;
		},

		initialize: function() {
			var self = this;
			this.set('isDirty', false, {
				silent: true
			});

			self.listenTo(this, 'monitor:change', function() {
				self.set('isDirty', true, {
					silent: true
				});
			});

			self.listenTo(this, 'change', function() {
				self.set('isDirty', true, {
					silent: true
				});
			});

			this.listenTo(appBus, 'segment:reloaded', this.validateSegments);
			this.listenTo(appBus, 'report:reloaded', this.validateMetrics);
		},

		defaults: function() {
			return {
				modelName: strings.monitorModelName,
				metrics: [],
				segments: [],
				options: {},
				isDirty: false,
				isPrivate: true,
				isRecentlyImported: false,
				owner: sessionStore.getApiUsername()
			};
		},

		getMetrics: function() {
			return this.get('metrics');
		},

		addMetric: function(metricId) {
			this.getMetrics().push(metricId);
		},

		getSegments: function() {
			return this.get('segments');
		},

		addSegment: function(segmentId) {
			this.getSegments().push(segmentId);
		},

		getMonitorData: function() {
			return this.serialize();
		},

		run: function() {
			var self = this;
			this.trigger('run');

			var requestData = this.getMonitorData();
			var debugData = {
				request: requestData
			};
			App.reportLog.push(debugData);

			return $.ajax(config.apiRoot + 'service/runmonitor', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(requestData)
			}).then(function(result) {
				self.set('results', new MonitorData(result.data, self), {
					silent: true
				});

				self.trigger('monitor:dataReceived');
			});
		},

		hasResults: function() {
			return !!this.get('results');
		},

		getResults: function() {
			return this.get('results');
		},

		setVisualization: function(name) {
			this.setOption('selectedVisualization', name);
			this.trigger('change:visualization');
		},

		getVisualization: function() {
			return this.getOption('selectedVisualization') || 'table';
		},

		getDomain: function() {
			return this.get('domain');
		},

		setDomain: function(domain) {
			return this.set('domain', domain);
		},

		getDomainName: function() {
			return this.get('domain').get('name');
		},

		getDashboardId: function() {
			return this.get('dashboardId');
		},

		setDashboardId: function(d) {
			return this.set('dashboardId', d);
		},

		getOptions: function() {
			return this.get('options');
		},

		getOption: function(key) {
			return this.get('options')[key];
		},

		setOption: function(key, value) {
			this.get('options')[key] = value;
		},

		isRunnable: function() {
			return this.getMetrics().length > 0 && this.getSegments().length > 0;
		},

		noMetrics: function() {
			return this.getMetrics() && this.getMetrics().length === 0;
		},

		noSegments: function() {
			return this.getSegments() && this.getSegments().length === 0;
		},

		isDirty: function() {
			return !!this.get('isDirty');
		},

		clean: function() {
			this.set('isDirty', false, {
				silent: true
			});
		},

		isNew: function() {
			return !this.get('id');
		},

		toJSON: function() {
			var serialized = {};

			serialized.id = this.get('id');
			serialized.domainId = this.get('domainId');
			serialized.dashboardId = this.get('dashboardId');

			serialized.name = this.getName();
			serialized.description = this.getDescription();
			serialized.isPrivate = this.getIsPrivate();
			serialized.metrics = this.getMetrics();
			serialized.segments = this.getSegments();
			serialized.options = JSON.stringify(this.getOptions());
			return serialized;
		},

		parse: function(data) {
			if (data && data.options) {
				data.options = JSON.parse(data.options);
			}

			return data;
		},

		save: function() {
			var jsonData = this.toJSON();

			var self = this;
			return $.ajax(config.apiRoot + 'service/monitor', {
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify(jsonData)
			}).then(function(data) {
				self.set('id', data.id);
				return {
					id: data.id,
					domainId: data.domainId,
					dashboardId: data.dashboardId
				};
			});
		},

		validateSegments: function() {
			var self = this;
			var domain = self.getDomain();
			if (!domain) {
				domain = App.domains.get(self.get('domainId'));
				if (!domain) {
					return;
				}
				self.setDomain(domain);
			}
			var monitorSegments = self.getSegments();
			var domainSegments = domain.getSegments();
			var validatedSegments = [];

			_.each(monitorSegments, function(id) {
				var exist = _.find(domainSegments, function(s) {
					return _.isEqual(s.getId(), id);
				});
				if (exist) {
					validatedSegments.push(id);
				}
			});
			this.set('segments', validatedSegments);
			this.trigger('monitor:refresh');
		},

		validateMetrics: function() {
			var self = this;
			var domain = self.getDomain();
			if (!domain) {
				domain = App.domains.get(self.get('domainId'));
				if (!domain) {
					return;
				}
				self.setDomain(domain);
			}
			var monitorMetrics = self.getMetrics();
			var domainMetrics = domain.getMetrics();
			var validatedMetrics = [];

			_.each(monitorMetrics, function(id) {
				var exist = _.find(domainMetrics, function(s) {
					return _.isEqual(s.getId(), id);
				});
				if (exist) {
					validatedMetrics.push(id);
				}
			});
			this.set('metrics', validatedMetrics);
			this.trigger('monitor:refresh');
		}
	});
});

